// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-form-heading {
    font-weight: 500;
    font-size: 28px;
    opacity: .85;
}

.common-form-heading.inner-heading {
    position: relative;
    z-index: 1;
}

.common-form-heading.inner-heading span {
    position: relative;
    z-index: 3;
    padding-right: 20px;
    background-color: #fff;
}

.common-form-heading.inner-heading::before {
    border-top: 2px solid #dfdfdf;
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: -1;
}

.image-upload-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
}

/* customize date picker */

.custom-date-picker .rmdp-container {
    width: 100%;
    display: block;
}

.custom-date-picker .rmdp-container input {
    padding: 17px 20px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/css/form.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;AACjC;;AAEA,0BAA0B;;AAE1B;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".common-form-heading {\n    font-weight: 500;\n    font-size: 28px;\n    opacity: .85;\n}\n\n.common-form-heading.inner-heading {\n    position: relative;\n    z-index: 1;\n}\n\n.common-form-heading.inner-heading span {\n    position: relative;\n    z-index: 3;\n    padding-right: 20px;\n    background-color: #fff;\n}\n\n.common-form-heading.inner-heading::before {\n    border-top: 2px solid #dfdfdf;\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: -1;\n}\n\n.image-upload-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-around;\n}\n\n/* customize date picker */\n\n.custom-date-picker .rmdp-container {\n    width: 100%;\n    display: block;\n}\n\n.custom-date-picker .rmdp-container input {\n    padding: 17px 20px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
